/**
 * Barra inferior "Servicios". Si `VITE_SHOW_SERVICIOS_NAV` no está definido:
 * visible en `npm run dev`, oculta en `vite build` (producción).
 */
export function isServiciosNavVisible() {
  const v = import.meta.env.VITE_SHOW_SERVICIOS_NAV;
  const s = String(v ?? '').trim().toLowerCase();
  if (s === 'false' || s === '0' || s === 'no' || s === 'off') return false;
  if (s === 'true' || s === '1' || s === 'yes' || s === 'on') return true;
  return Boolean(import.meta.env.DEV);
}
